import {Component, HostBinding} from '@angular/core';
import {LoaderService} from 'app/modules/common/ngx-http-loader/loader-service/services/loader.service';
import {PendingInterceptorService} from 'app/modules/common/ngx-http-loader/loader-service/services/pending-interceptor.service';
import 'rxjs/add/operator/delay';

const componentBaseName = 'loader';
const defaultClassNames = [componentBaseName + '-component'];

const timeoutOffset = 100;

/**
 * Component to display and hide a global loading indicator
 *
 */
@Component({
  selector: 'cat-loader',
  templateUrl: './loader.component.html',
})
export class LoaderComponent {
  @HostBinding('attr.class') className = defaultClassNames.join(' ');

  doDisplayIndicator = false;

  legacyLoaderHasPendingRequests = false;
  stateOfTheArtLoaderHasPendingRequests = false;

  private currentTimeout;
  private timeoutOffset = 100;

  constructor(interceptorService: PendingInterceptorService, loaderService: LoaderService) {
    loaderService
      .loaderState
      .delay(timeoutOffset)
      .subscribe((state) => {
      this.legacyLoaderHasPendingRequests = state.show;
      this.updateLoaderState();
    });

    interceptorService
      .pendingRequestsStatus
      .delay(timeoutOffset)
      .subscribe((hasPendingRequests: boolean) => {
        this.stateOfTheArtLoaderHasPendingRequests = hasPendingRequests;
        this.updateLoaderState();
      });
  }

  private updateLoaderState() {
    this.doDisplayIndicator = this.legacyLoaderHasPendingRequests || this.stateOfTheArtLoaderHasPendingRequests;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/common/ngx-http-loader/loader-service/components/loader/loader.component.ts